import { render, staticRenderFns } from "./SideContent.vue?vue&type=template&id=54861d64&"
import script from "./SideContent.vue?vue&type=script&lang=js&"
export * from "./SideContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QList,QItem,QItemSection,QItemLabel,QImg,QVideo,QDialog,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QList,QItem,QItemSection,QItemLabel,QImg,QVideo,QDialog})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
